module.exports = __webpack_public_path__ + "img/adult-blood-control.2973a890.jpg";